function getRideSaved() {
  const sources = [];
  try { sources.push(localStorage.getItem('ride')); } catch (error) {}
  try {
    const cookie = document.cookie.match(/(?:^|;)\s*ride=([^;]+)/);
    if (cookie) sources.push(decodeURIComponent(cookie[1]));
  } catch (error) {}
  for (const source of sources) {
    try {
      const value = JSON.parse(source);
      if (value && typeof value.make === 'string' && typeof value.model === 'string') return value;
    } catch (error) {}
  }
  return null;
}

(function () {
  const dataElement = document.getElementById('autv-vehicle-catalog');
  if (!dataElement) return;
  let catalog;
  try { catalog = JSON.parse(dataElement.textContent); } catch (error) { return; }
  const index = Object.create(null);
  const labels = catalog.labels;
  const formStates = new Map();
  const makeKey = 'filter.p.m.custom.make';
  const modelKey = 'filter.p.m.custom.models';
  function display(value) {
    return value.trim().replace(/^Can Am$/, 'Can-Am').replace(/^Mav R/, 'Maverick R').replace(/1000r/g, '1000R').replace(/1000x/g, '1000X');
  }
  catalog.makes.forEach(function (make) {
    if (!make.value || make.value === 'Universal') return;
    const models = catalog.models.filter(function (model) { return model.make === make.id && model.value; }).map(function (model) { return model.value; });
    if (models.length) index[make.value] = Array.from(new Set(models)).sort(function (a, b) { return a.localeCompare(b, undefined, { numeric: true }); });
  });
  window.VEHICLE_MODEL_INDEX = index;

  function normalizeRide(ride) {
    if (!ride || !index[ride.make] || typeof ride.model !== 'string') return null;
    const model = index[ride.make].find(function (value) { return value.trim() === ride.model.trim(); });
    return model ? { make: ride.make, model: model, universal: ride.universal === true } : null;
  }
  function writeRide(ride) {
    try { if (ride) localStorage.setItem('ride', JSON.stringify(ride)); else localStorage.removeItem('ride'); } catch (error) {}
    try { document.cookie = ride ? 'ride=' + encodeURIComponent(JSON.stringify(ride)) + ';path=/;max-age=31536000;SameSite=Lax' : 'ride=;path=/;max-age=0;SameSite=Lax'; } catch (error) {}
  }
  function filterUrl(href, ride, target) {
    const url = new URL(href);
    if (target) url.pathname = target;
    url.hash = '';
    url.searchParams.delete('autv_directory');
    url.searchParams.delete('page');
    url.searchParams.delete(makeKey);
    url.searchParams.delete(modelKey);
    if (ride) {
      url.searchParams.append(makeKey, ride.make);
      url.searchParams.append(modelKey, ride.model);
      if (ride.universal) {
        url.searchParams.append(makeKey, 'Universal');
        url.searchParams.append(modelKey, 'Universal');
      }
    }
    return url.toString();
  }
  function sync() {
    const ride = normalizeRide(getRideSaved());
    document.querySelectorAll('[data-autv-summary]').forEach(function (element) { element.textContent = ride ? display(ride.make) + ' ' + display(ride.model) : labels.title; });
    formStates.forEach(function (state) {
      state.make.value = ride ? ride.make : '';
      populateModels(state, state.make.value, ride ? ride.model : '');
      state.universal.checked = Boolean(ride && ride.universal);
      state.clear.hidden = !ride;
      state.status.textContent = ride ? labels.saved + ' ' + display(ride.make) + ' ' + display(ride.model) : '';
      updateShortcuts(state);
    });
  }
  function updateShortcuts(state) {
    state.form.querySelectorAll('[data-autv-make-value]').forEach(function (button) { button.setAttribute('aria-pressed', String(button.dataset.autvMakeValue === state.make.value)); });
  }
  function populateModels(state, make, selected) {
    state.model.replaceChildren(new Option(make ? labels.chooseModel : labels.chooseMakeFirst, ''));
    (index[make] || []).forEach(function (model) { state.model.add(new Option(display(model), model)); });
    state.model.disabled = !(index[make] && index[make].length);
    state.model.value = selected || '';
    state.submit.disabled = !state.model.value;
  }
  function initialize() {
    document.querySelectorAll('[data-autv-ride-form]').forEach(function (form) {
      if (formStates.has(form)) return;
      const state = { form: form, make: form.querySelector('[data-autv-make]'), model: form.querySelector('[data-autv-model]'), universal: form.querySelector('[data-autv-universal]'), submit: form.querySelector('[data-autv-submit]'), clear: form.querySelector('[data-autv-clear]'), status: form.querySelector('[data-autv-status]') };
      formStates.set(form, state);
      const shortcuts = form.querySelector('[data-autv-make-shortcuts]');
      Object.keys(index).sort(function (a, b) { const priority = { Polaris: 0, 'Can Am': 1, Honda: 2, Yamaha: 3, Kawasaki: 4 }; return (priority[a] ?? 10) - (priority[b] ?? 10) || a.localeCompare(b); }).forEach(function (make) {
        state.make.add(new Option(display(make), make));
        if (!shortcuts) return;
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'autv-ride__make-shortcut';
        button.dataset.autvMakeValue = make;
        const photo = Array.from(form.closest('[data-autv-ride]')?.querySelectorAll('[data-autv-photo-make]') || []).find(function (template) { return template.dataset.autvPhotoMake === make; });
        if (photo) {
          button.append(photo.content.cloneNode(true));
          button.classList.add('autv-ride__make-shortcut--photo');
        }
        const name = document.createElement('span');
        name.className = 'autv-ride__make-name';
        name.textContent = display(make);
        button.append(name);
        const arrow = document.createElement('span');
        arrow.className = 'autv-ride__brand-arrow';
        arrow.setAttribute('aria-hidden', 'true');
        arrow.textContent = '→';
        button.append(arrow);
        button.setAttribute('aria-pressed', 'false');
        button.addEventListener('click', function () {
          state.make.value = make;
          populateModels(state, make, '');
          updateShortcuts(state);
          state.model.focus();
        });
        shortcuts.append(button);
      });
      state.make.addEventListener('change', function () { populateModels(state, state.make.value); updateShortcuts(state); });
      state.model.addEventListener('change', function () { state.submit.disabled = !state.model.value; });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        const ride = normalizeRide({ make: state.make.value, model: state.model.value, universal: state.universal.checked });
        if (!ride) return;
        writeRide(ride);
        const path = window.location.pathname;
        const target = /\/collections\//.test(path) && !/\/products\//.test(path) ? null : new URL(form.action).pathname;
        window.location.assign(filterUrl(window.location.href, ride, target));
      });
      state.clear.addEventListener('click', function () {
        writeRide(null);
        sync();
        if (/\/collections\//.test(window.location.pathname) && !/\/products\//.test(window.location.pathname)) window.location.assign(filterUrl(window.location.href, null));
      });
    });
    sync();
  }
  document.addEventListener('click', function (event) {
    const link = event.target.closest('a[data-autv-directory-link]');
    if (!link) return;
    const ride = normalizeRide({ make: link.dataset.autvDirectoryMake, model: link.dataset.autvDirectoryModel, universal: false });
    writeRide(ride);
    sync();
    const url = new URL(link.href);
    const preview = new URL(window.location.href).searchParams.get('preview_theme_id');
    if (preview) url.searchParams.set('preview_theme_id', preview);
    link.href = url.toString();
  });
  document.addEventListener('click', function (event) { document.querySelectorAll('details[data-autv-ride][open]').forEach(function (details) { if (!details.contains(event.target)) details.open = false; }); });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('details[data-autv-ride][open]').forEach(function (details) { details.open = false; if (details.contains(document.activeElement)) details.querySelector('summary').focus(); });
  });
  window.addEventListener('storage', function (event) { if (event.key === 'ride') sync(); });
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('shopify:section:unload', function (event) { formStates.forEach(function (state, form) { if (event.target.contains(form)) formStates.delete(form); }); });
  window.AmericanUTVRide = { filterUrl: filterUrl, normalizeRide: normalizeRide };
  initialize();
})();


